export default __webpack_public_path__ + "static/media/category_11.c0f413ec.png";